// import React, { useEffect, useState } from 'react';
// import { IoReorderThreeOutline } from 'react-icons/io5';
// import { TfiMenu } from "react-icons/tfi";
// // import '../../assets/css/map.css';

// const MapSidebar = React.memo(({ ambulancePhotosApi }) => {
//   const [photos, setPhotos] = useState([]);

//   console.log('ambulancePhotosApi', ambulancePhotosApi);

//   useEffect(() => {
//     const fetchAmbulancePhotos = async () => {
//       try {
//         const response = await fetch(ambulancePhotosApi);
//         const allPhotos = await response.json();

//         // Sort and set photos state
//         const sortedPhotos = allPhotos.sort(
//           (a, b) => new Date(b.date_added) - new Date(a.date_added)
//         );
//         setPhotos((prevPhotos) => {
//           // Avoid unnecessary state updates
//           if (JSON.stringify(prevPhotos) === JSON.stringify(sortedPhotos)) {
//             return prevPhotos;
//           }
//           return sortedPhotos;
//         });
//       } catch (error) {
//         console.error('Error fetching ambulance photos:', error);
//       }
//     };

//     fetchAmbulancePhotos();

//     // const photoInterval = setInterval(fetchAmbulancePhotos, 15000);
//     // return () => clearInterval(photoInterval);
//   }, [ambulancePhotosApi]);

//   const formatTimestamp = (timestamp) => {
//     const [datePart, timePart] = timestamp.split(' ');
//     const [year, month, day] = datePart.split('-');
//     const [hours, minutes] = timePart.split(':');

//     // Create a Date object in local timezone
//     const date = new Date(year, month - 1, day, hours, minutes);

//     // Adjust to Asia/Kolkata time (UTC+5:30)
//     date.setHours(date.getHours() + 5);
//     date.setMinutes(date.getMinutes() + 30);

//     return date.toLocaleTimeString('en-GB', {
//       hour: '2-digit',
//       minute: '2-digit',
//     });
//   };

//   const getIconForCode = (code) => {
//     switch (code.trim()) {
//       case 'Code green':
//         return 'green-alert.png';
//       case 'Code blue':
//         return 'blue-alert.png';
//       default:
//         return 'white-alert.png';
//     }
//   };

//   const renderPhotos = (photoString, name) => {
//     if (!photoString.trim()) {
//       return '-';
//     }

//     const photoArray = photoString
//       .split(',')
//       .map((url) => url.trim())
//       .filter(Boolean);

//     return photoArray.map((photoPath, index) => (
//       <img
//         key={index}
//         src={photoPath}
//         alt={name}
//         style={{
//           margin: '5px',
//           width: '30px',
//           height: '30px',
//           cursor: 'pointer',
//         }}
//         onClick={() => openModal(photoPath)}
//       />
//     ));
//   };

//   const openModal = (photoPath) => {
//     // Implement modal logic here
//     console.log('Open modal with photo:', photoPath);
//   };

//   return (
//     <div
//       style={{
//         width: '350px',
//         overflowY: 'auto',
//         backgroundColor: 'white',
//         padding: '10px',
//         borderRight: '1px solid #ddd',
//       }}
//     >
//         <div style={{display:'flex', gap:10, alignItems:'center'}}>
//         <TfiMenu style={{color:"#007bff"}} size={22}/>
//         <h3 style={{marginTop:'0px !important'}}>Incident Timeline</h3>
//         </div>

//       <table id='incidents'>
//         <thead>
//           <tr>
//             <th width='30' >TIME</th>
//             <th width='30' >UNIT</th>
//             <th width='30' >CODE</th>
//             <th width='100' >DESCRIPTION</th>
//             <th width='100' >PHOTO</th>
//           </tr>
//         </thead>
//         <tbody id='photoList'></tbody>
//         <tbody>
//           {photos.map((photo, index) => (
//             <tr key={index}>
//               <td>{formatTimestamp(photo.date_added)}</td>
//               <td>{photo.name}</td>
//               <td>
//                 <img
//                   src={`icons/${getIconForCode(photo.emcode)}`}
//                   alt={photo.emcode}
//                   width='28'
//                   height='28'
//                 />
//               </td>
//               <td>{photo.description}</td>
//               {/* <td>{renderPhotos(photo.photo, photo.name)}</td> */}
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// });

// export default MapSidebar;

import { useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { TfiMenu } from 'react-icons/tfi';
import eventLogo from '../../assets/images/event_logo.png';
import { filter, find, isEmpty } from 'lodash';
import moment from 'moment';
import { PhotoModal } from './AmbulanceMap';
import { useLocation } from 'react-router-dom';
import eventService from '../../services/eventService';
// import '../../assets/css/map.css';

const MapSidebar = React.memo(
  ({
    ambulancePhotosApi,
    setShowSidebar,
    showSidebar = true,
    eventDetails = {},
    setSelectedPhoto,
  }) => {
    const location = useLocation();
    const [photos, setPhotos] = useState([]);
    const [event, setEvent] = useState('');
    const [showImage, setShowImage] = useState(false);
    const eventObj = location?.pathname === '/incidents' ? event : eventDetails;
    // const [selectedPhoto, setSelectedPhoto] = useState(null);

    const Api = `${process.env.REACT_APP_API_URL}/gps_unit_photo/gps_unit_photo_active_ev/${event?.id}`;

    useEffect(() => {
      if (location?.pathname === '/incidents' && !ambulancePhotosApi) {
        const fetchEvents = async () => {
          const response = await eventService.getEvents();
          setEvent(find(response.data, { active: true }));
        };
        fetchEvents();
      }
    }, []);

    useEffect(() => {
      const fetchAmbulancePhotos = async () => {
        try {
          const response = await fetch(
            ambulancePhotosApi ? ambulancePhotosApi : Api
          );
          const allPhotos = await response.json();

          // Sort and set photos state
          const sortedPhotos = allPhotos?.sort(
            (a, b) => new Date(b.date_added) - new Date(a.date_added)
          );
          setPhotos((prevPhotos) => {
            // Avoid unnecessary state updates
            if (JSON.stringify(prevPhotos) === JSON.stringify(sortedPhotos)) {
              return prevPhotos;
            }
            return sortedPhotos;
          });
        } catch (error) {
          console.error('Error fetching ambulance photos:', error);
        }
      };

      if (eventObj?.id) {
        fetchAmbulancePhotos(); // Initial fetch when eventDetails changes
      }

      const photoInterval = setInterval(fetchAmbulancePhotos, 30000); // 30 seconds

      // Cleanup the interval on component unmount or when eventDetails change
      return () => clearInterval(photoInterval);
    }, [eventObj]); // Re-run when eventDetails changes

    const formatTimestamp = (timestamp) => {
      const [datePart, timePart] = timestamp?.split(' ');
      const [year, month, day] = datePart?.split('-');
      const [hours, minutes] = timePart?.split(':');

      // Create a Date object in local timezone
      const date = new Date(year, month - 1, day, hours, minutes);

      // Adjust to Asia/Kolkata time (UTC+5:30)
      date?.setHours(date.getHours());
      date?.setMinutes(date.getMinutes());

      return date.toLocaleTimeString('en-GB', {
        hour: '2-digit',
        minute: '2-digit',
      });
    };

    const getIconForCode = (code) => {
      switch (code.trim()) {
        case 'Code green':
          return 'green-alert.png';
        case 'Code blue':
          return 'blue-alert.png';
        default:
          return 'white-alert.png';
      }
    };

    const renderPhotos = (photoString, name) => {
      if (!photoString.trim()) {
        return '-';
      }

      const photoArray = photoString
        .split(',')
        .map((url) => url.trim())
        .filter(Boolean);

      return photoArray.map((photoPath, index) => (
        <img
          key={index}
          src={`${process.env.REACT_APP_IMAGE_URL}/images/${photoPath}`}
          alt={name}
          style={{
            margin: isMobile ? '3px' : isTablet ? '4px' : '5px',
            width: isMobile ? '6px' : isTablet ? '24px' : '30px',
            height: isMobile ? '6px' : isTablet ? '24px' : '30px',
            cursor: 'pointer',
          }}
          onClick={() => openModal(photoPath)}
        />
      ));
    };

    const openModal = (photoPath) => {
      if (location?.pathname === '/incidents') {
        setShowImage(photoPath);
      } else {
        setSelectedPhoto(photoPath); // Set the photo to be shown in the modal
      }
    };

    const closeModal = () => {
      setShowImage(null); // Close the modal
    };

    //   const cellStyle = {
    //     fontFamily: 'Arial, Helvetica, sans-serif',
    //     fontSize: '10px',
    //     border: '1px solid #ddd',
    //     padding: '2px',
    //     textTransform: 'uppercase',
    //     textAlign: 'left',
    //   };
    const theme = useTheme();

    // MUI breakpoints to check for mobile and tablet sizes
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Mobile (<=600px)
    const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md')); // Tablet (600px to 1024px)

    const headStyle = {
      backgroundColor: '#04AA6D',
      color: 'white',
      padding: '8px 2px',
      border: '1px solid #ddd',
      textAlign: 'left',
      borderRadius: '0px',
      fontWeight: 800,
      fontSize: isMobile ? '4px' : isTablet ? '8px' : '10.5px', // Adjusted font size
    };

    const cellStyle = {
      fontFamily: 'Arial, Helvetica, sans-serif',
      border: '1px solid #ddd',
      padding: '2px',
      textTransform: 'uppercase',
      fontSize: isMobile ? '4px' : isTablet ? '8px' : '10px', // Adjusted font size
    };

    return (
      <div
        style={{
          width: 'auto',
          overflowY: 'auto',
          backgroundColor: 'white',
          padding: '10px',
          borderRight: '1px solid #ddd',
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <img
            src={`${process.env.REACT_APP_IMAGE_URL}/images/${eventObj?.photo}`}
            className='responsive-logo'
            style={
              {
                // maxWidth: '18vw',
                // height: 'auto',
                // transition: 'max-width 0.3s ease',
              }
            }
          />
        </div>

        <div
          style={{
            display: 'flex',
            gap: 10,
            alignItems: 'center',
            marginTop: 12,
          }}
        >
          {location?.pathname !== '/incidents' && (
            <TfiMenu
              style={{ color: '#007bff' }}
              onClick={() => setShowSidebar(false)}
              cursor='pointer'
            />
          )}
          <h3 style={{ margin: 0 }}>Incident Timeline</h3>
        </div>

        <table
          style={{
            width: '100%',
            borderCollapse: 'collapse',
            marginTop: '10px',
          }}
        >
          <thead>
            <tr>
              <th width='30' style={headStyle}>
                TIME
              </th>
              <th width='30' style={headStyle}>
                UNIT
              </th>
              <th width='30' style={headStyle}>
                CODE
              </th>
              <th width='30' style={headStyle}>
                DESCRIPTION
              </th>
              <th width='100' style={headStyle}>
                PHOTO
              </th>
            </tr>
          </thead>
          <tbody id='photoList'></tbody>
          <tbody>
            {!isEmpty(photos) &&
              photos?.map((photo, index) => (
                <tr key={index}>
                  <td style={cellStyle}>
                    {photo.date_added
                      ? formatTimestamp(
                          moment(photo.date_added).format('YYYY-MM-DD HH:mm')
                        )
                      : '-'}
                  </td>
                  <td style={cellStyle}>{photo.name}</td>
                  <td style={cellStyle}>
                    <img
                      src={`icons/${getIconForCode(photo.emcode)}`}
                      alt={photo.emcode}
                      width={isMobile ? '15' : isTablet ? '25' : '28'}
                      height={isMobile ? '15' : isTablet ? '25' : '28'}
                    />
                  </td>
                  <td style={cellStyle}>{photo.description}</td>
                  <td style={cellStyle}>
                    {renderPhotos(photo.photo, photo.name)}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
        {showImage && <Modal onClose={closeModal} photoPath={showImage} />}
      </div>
    );
  }
);

export default MapSidebar;

// import React, { useEffect, useState } from 'react';
// import { TfiMenu } from 'react-icons/tfi';

// const MapSidebar = React.memo(({ ambulancePhotosApi }) => {
//   const [photos, setPhotos] = useState([]);

//   useEffect(() => {
//     const fetchAmbulancePhotos = async () => {
//       try {
//         const response = await fetch(ambulancePhotosApi);
//         const allPhotos = await response.json();
//         const sortedPhotos = allPhotos.sort(
//           (a, b) => new Date(b.date_added) - new Date(a.date_added)
//         );
//         setPhotos(sortedPhotos);
//       } catch (error) {
//         console.error('Error fetching ambulance photos:', error);
//       }
//     };

//     fetchAmbulancePhotos();
//   }, [ambulancePhotosApi]);

//   const formatTimestamp = (timestamp) => {
//     const [datePart, timePart] = timestamp.split(' ');
//     const [year, month, day] = datePart.split('-');
//     const [hours, minutes] = timePart.split(':');
//     const date = new Date(year, month - 1, day, hours, minutes);
//     date.setHours(date.getHours() + 5);
//     date.setMinutes(date.getMinutes() + 30);
//     return date.toLocaleTimeString('en-GB', {
//       hour: '2-digit',
//       minute: '2-digit',
//     });
//   };

//   const renderPhotos = (photoString) => {
//     const photoArray = photoString
//       .split(',')
//       .map((url) => url.trim())
//       .filter(Boolean);

//     return photoArray.map((photoPath, index) => (
//       <img
//         key={index}
//         src={photoPath}
//         // alt='Incident'
//         style={{
//           margin: '5px',
//           width: '18px',
//           height: '18px',
//           cursor: 'pointer',
//           border: '1px solid #ccc',
//         }}
//       />
//     ));
//   };

//   const getIconForCode = (code) => {
//     switch (code.trim()) {
//       case 'Code green':
//         return 'green-alert.png';
//       case 'Code blue':
//         return 'blue-alert.png';
//       default:
//         return 'white-alert.png';
//     }
//   };

//   const cellStyle = {
//     fontFamily: 'Arial, Helvetica, sans-serif',
//     fontSize: '10px',
//     border: '1px solid #ddd',
//     padding: '2px',
//     textTransform: 'uppercase',
//     textAlign: 'left',
//   };

//   const headStyle = {
//     backgroundColor: '#4CAF50',
//     color: 'white',
//     padding: '8px 2px',
//     border: '1px solid #ddd',
//     textAlign: 'left',
//     borderRadius: '0px',
//     fontSize: '9px',
//   };

//   return (
//     <div
//       style={{
//         width: '400px',
//         overflowY: 'auto',
//         backgroundColor: 'white',
//         padding: '10px',
//         borderRight: '1px solid #ddd',
//       }}
//     >
//       <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
//         <TfiMenu style={{ color: '#007bff' }} size={22} />
//         <h3 style={{ margin: 0 }}>Incident Timeline</h3>
//       </div>

//       <table
//         style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}
//       >
//         <thead>
//           <tr>
//             <th style={headStyle} >TIME</th>
//             <th style={headStyle} >UNIT</th>
//             <th style={headStyle} >CODE</th>
//             <th style={headStyle} >DESCRIPTION</th>
//             <th style={headStyle} >PHOTO</th>
//           </tr>
//         </thead>
//         <tbody>
//           {photos.map((photo, index) => (
//             <tr key={index}>
//               <td style={cellStyle} width='30'>{formatTimestamp(photo.date_added)}</td>
//               <td style={cellStyle} width='30'>{photo.name}</td>
//               <td style={cellStyle} width='30'>
//                 <img
//                   src={`icons/${getIconForCode(photo.emcode)}`}
//                   alt={photo.emcode}
//                   width='28'
//                   height='28'
//                 />
//               </td>
//               <td style={cellStyle} width='100'>{photo.description}</td>
//               <td style={{...cellStyle, display:'flex', width:'95%'}} width='100'>{renderPhotos(photo.photo)}</td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// });

// export default MapSidebar;

const Modal = ({ photoPath, onClose }) => {
  if (!photoPath) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <div
        style={{
          position: 'relative',
          backgroundColor: 'white',
          padding: '10px',
          borderRadius: '8px',
          maxWidth: '90vw', // Makes the modal container responsive
          maxHeight: '90vh', // Limits the modal size to 90% of the viewport
          display: 'flex',
          justifyContent: 'center', // Centering the image horizontally
          alignItems: 'center', // Centering the image vertically
        }}
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside modal
      >
        <img
          src={`${process.env.REACT_APP_IMAGE_URL}/images/${photoPath}`}
          alt='Photo'
          style={{
            maxWidth: '100%', // Ensure image is fully responsive
            maxHeight: '80vh', // Limit image size to avoid overflowing vertically
            borderRadius: '8px',
          }}
        />
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            backgroundColor: 'transparent',
            border: 'none',
            color: 'white',
            fontSize: '20px',
            cursor: 'pointer',
          }}
        >
          X
        </button>
      </div>
    </div>
  );
};
